module.exports = __webpack_public_path__ + "static/media/CustomIconScienceBig.1b247b2e.svg";